<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <table class="w-full d-none d-md-table">
            <thead>
            <tr class="h-11">
                <th class="pl-3">#</th>
                <th>{{ $t('kpi.employee.title') }}</th>
                <th>{{ $t('kpi.salePlan') }}</th>
                <th>{{ $t('kpi.done') }}</th>
                <th>{{ $t('kpi.planDone') }}</th>
                <th>{{ $t('actions') }}</th>
            </tr>
            </thead>
            <tbody v-if="getEmployees.length">
            <tr v-for="employee of getEmployees" :key="employee.id" class="h-11">
                <td class="pl-3">{{ employee.person.id }}</td>
                <td>
                    <div class="d-flex align-items-center">
                        <img
                            :src="employee.person.image ? url + employee.person.image.contentUrl : ''"
                            style="border-radius: 50%;"
                            height="34px"
                            alt=""
                            @click="setModal(employee.person.givenName, url + employee.person.image.contentUrl)"
                            class="d-none d-md-table-cell"
                        >
                        <router-link :to="$i18nHelper.getUrl('employee/' + employee.person.id)" class="d-none d-sm-block ml-2">
                            &ensp;{{ employee.person.givenName + ' ' + employee.person.familyName + ' ' + employee.person.additionalName }}
                        </router-link>
                        <router-link :to="$i18nHelper.getUrl('employee/' + employee.person.id)" class="d-block d-sm-none ml-1">
                            {{ employee.person.givenName }}
                        </router-link>
                    </div>
                </td>
                <td>{{ showCurrencyById(getCurrencyByShortName(baseCurrencyShortName).id, employee.estimateSale) }}</td>
                <td>{{ showCurrencyById(getCurrencyByShortName(baseCurrencyShortName).id, employee.realSale) }}</td>
                <td>{{ +employee.realSale >= +employee.estimateSale ? $t('yes') : $t('no') }}</td>
                <td>
                    <img src="/images/edit.png" alt="" class="h-6 cursor-pointer" @click="$i18nHelper.toUrl('employee/' + employee.person.id)">
                </td>
            </tr>
            </tbody>
        </table>

        <table v-if="getEmployees.length" class="table-striped d-md-none w-100">
            <tbody v-for="employee of getEmployees" :key="employee.id" style="border-bottom: 5px solid #777777">
                <tr style="height: 45px">
                    <th class="px-2">#</th>
                    <td class="px-2">{{ employee.person.id }}</td>
                </tr>
                <tr style="height: 45px">
                    <th class="px-2">{{ $t('kpi.employee.title') }}</th>
                    <td class="px-2">
                        <div class="d-flex align-items-center">
                            <img
                                :src="employee.person.image ? url + employee.person.image.contentUrl : ''"
                                style="border-radius: 50%;"
                                height="34px"
                                alt=""
                                @click="setModal(employee.person.givenName, url + employee.person.image.contentUrl)"
                                class="d-none d-md-table-cell"
                            >
                            <router-link :to="$i18nHelper.getUrl('employee/' + employee.person.id)" class="d-none d-sm-block ml-2">
                                &ensp;{{ employee.person.givenName + ' ' + employee.person.familyName + ' ' + employee.person.additionalName }}
                            </router-link>
                            <router-link :to="$i18nHelper.getUrl('employee/' + employee.person.id)" class="d-block d-sm-none ml-1">
                                {{ employee.person.givenName }}
                            </router-link>
                        </div>
                    </td>
                </tr>
                <tr style="height: 45px">
                    <th class="px-2">{{ $t('kpi.salePlan') }}</th>
                    <td class="px-2">{{ showCurrencyById(getCurrencyByShortName(baseCurrencyShortName).id, employee.estimateSale) }}</td>
                </tr>
                <tr style="height: 45px">
                    <th class="px-2">{{ $t('kpi.done') }}</th>
                    <td class="px-2">{{ showCurrencyById(getCurrencyByShortName(baseCurrencyShortName).id, employee.realSale) }}</td>
                </tr>
                <tr style="height: 45px">
                    <th class="px-2">{{ $t('kpi.planDone') }}</th>
                    <td class="px-2">{{ employee.realSale >= employee.estimateSale ? $t('yes') : $t('no') }}</td>
                </tr>
                <tr style="height: 45px">
                    <th class="px-2">{{ $t('actions') }}</th>
                    <td class="px-2">
                        <img src="/images/edit.png" alt="" class="h-6 cursor-pointer" @click="$i18nHelper.toUrl('employee/' + employee.person.id)">
                    </td>
                </tr>
            </tbody>
        </table>

        <ModalWithPicture id="employee_picture" :img="itemImageUrl" :title="employeeGivenName"/>

    </Row>
</template>

<script>
import Row from "@/components/html/Row.vue";
import {mapActions, mapGetters} from "vuex";
import ModalWithPicture from "@/components/html/ModalWithPicture.vue";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "ViewPage",
    components: {Modal, ModalWithPicture, Row},
    mixins: [dateFormattingMixin, currencyFormatMixin],
    data() {
        return {
            url: process.env.VUE_APP_API_URL,
            employeeGivenName: '',
            itemImageUrl: '',
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'employee.title', url: 'employees/kpi/list'},
                {name: 'kpi.title', url: 'employees/kpi/list'},
                {name: 'employee.title'},
            ],
            modalText: '',
        }
    },
    computed: {
        ...mapGetters(['getEmployees', 'getEmployeesTotalCount', 'getCurrencyByShortName'])
    },
    methods: {
        ...mapActions(['fetchEmployeeKpi', 'setBreadcrumbItems']),
        setModal(givenName, url) {
            this.employeeGivenName = givenName
            this.itemImageUrl = url
            this.$bvModal.show('employee_picture')
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true

        this
            .fetchEmployeeKpi()
            .then(() => {
                this.$root.showOverlay = false
            })
            .catch((reason) => {
                this.$root.showOverlay = false

                this.modalText = reason
                this.$bvModal.show('modal_show')
            })
    }
}
</script>

<style scoped>

</style>
